module.exports = __webpack_public_path__ + "img/icon2.532b0143.svg";